export interface ArtikelOption {
  id: number;
  name: string;
  title: string;
  values: { id: number; title: string } [];
}
